module.exports = __webpack_public_path__ + "img/un-leave.88feea02.png";